import React, { useContext } from "react";
import axios from "axios";
import RegistrationContext from "../../contexts/RegistrationContext";
import { base_url, steps } from "../../config";
import getStepValue from "../../util/getStepValue";
import "./style.scss"; // Ensure this file contains the updated styles
import { CheckCircle } from "lucide-react";

function Stepper() {
  const {
    setReload,
    reload,
    setError,
    screen,
    maxStep,
    registrationType,
    optionAccess,
  } = useContext(RegistrationContext);

  const handler = async (step) => {
    setError("");
    try {
      await axios.post(`${base_url}/api/jump`, { step });
      setReload(reload + 1);
    } catch (error) {
      setError("Not accessible step");
    }
  };

  if (screen === "Confirmation") {
    return <div className="bg-black text-white h-8">&nbsp;</div>;
  }
  let count = 0;
  return (
    <div className="bg-black text-white">
      <div className="container text-xs p-4 ">
        <div className="stepper flex justify-left">
          {steps.map((step, index) => {
            let isGray = false;
            let isHidden = false;

            if (screen === "Confirmation") {
              isGray = step !== "Confirmation";
            } else {
              isGray = getStepValue(step) > getStepValue(maxStep);
            }

            if (
              ["industry", "exhibitor"].includes(registrationType) &&
              step === "Workshop Selection"
            ) {
              isHidden = true;
            }
            if (["industry", "exhibitor"].includes(registrationType) && step === "Paper Selection") {
              isHidden = true;
            }
            if (optionAccess === "workshops" && step === "Paper Selection") {
              isHidden = true;
            }
            if (["industry", "exhibitor"].includes(registrationType) && step === "Membership") {
              isHidden = true;
            }
            if (
              ["industry", "exhibitor"].includes(registrationType) &&
              step === "Additional Items"
            ) {
              isHidden = true;
            }
            if (registrationType === "student" && step === "Paper Selection") {
              isHidden = true;
            }
            if (isHidden) {
              return null;
            }
            if (maxStep === "Registration Type" && index > 0) {
              return null;
            }
            const isCompleted = getStepValue(step) < getStepValue(screen);
            const isCurrent = step === screen;

            count++;
            return (
              <div
                key={index}
                className={`step flex items-center ${
                  isGray ? "text-gray-400" : ""
                } ${
                  isCurrent
                    ? "current-step font-bold"
                    : "text-blue-400 font-bold"
                }`}
                onClick={() => (isGray ? null : handler(step))}
              >
                {isCompleted ? (
                  <CheckCircle className="text-blue-400  mr-2" size={14} />
                ) : (
                  <>
                    <span>{count}</span>.&nbsp;
                  </>
                )}
                <span>{step}</span>
                {index !== steps.length - 1 && (
                  <div className="step-connector"></div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

export default Stepper;
